import Action from 'redux/helpers/createAction'
const name = 'list'

export const getLists = Action(name + '/GET_LISTS')

export const getListsSuccess = Action(name + '/GET_LISTS_SUCCESS', lists => ({
  lists
}))

export const getListsFailure = Action(name + '/GET_LISTS_FAILURE', error => ({
  error
}))

export const getList = Action(name + '/GET_LIST', id => ({
  id
}))

export const getListSuccess = Action(name + '/GET_LIST_SUCCESS', list => ({
  list
}))

export const getListFailure = Action(name + '/GET_LIST_FAILURE', error => ({
  error
}))

export const addList = Action(name + '/ADD_LIST', payload => ({
  payload
}))

export const addListSuccess = Action(name + '/ADD_LIST_SUCCESS')

export const addListFailure = Action(name + '/ADD_LIST_FAILURE', error => ({
  error
}))

export const updateList = Action(name + '/UPDATE_LIST', (id, payload) => ({
  id,
  payload
}))

export const updateListSuccess = Action(name + '/UPDATE_LIST_SUCCESS', data => ({
  data: data.data.list
}))

export const updateListFailure = Action(name + '/UPDATE_LIST_FAILURE', error => ({
  error
}))

export const deleteList = Action(name + '/DELETE_LIST', id => ({
  id
}))

export const deleteListSuccess = Action(name + '/DELETE_LIST_SUCCESS')

export const deleteListFailure = Action(name + '/DELETE_LIST_FAILURE', error => ({
  error
}))

export const deleteListKeywords = Action(
  name + '/DELETE_LIST_KEYWORDS',
  (id, filters, keywordIds) => ({
    id,
    filters,
    keywordIds
  })
)

export const deleteListKeywordsSuccess = Action(name + '/DELETE_LIST_KEYWORDS_SUCCESS')

export const deleteListKeywordsFailure = Action(name + '/DELETE_LIST_KEYWORDS_FAILURE', error => ({
  error
}))

export const clearList = Action(name + '/CLEAR_LIST')

export const exportList = Action(name + '/EXPORT_LIST', id => ({
  id
}))
